export var ACTION;
(function (ACTION) {
    ACTION["CHANGE_TAB"] = "CHANGE_TAB";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["ON_SEARCH_RP"] = "ON_SEARCH_RP";
    ACTION["ON_SORT_RP"] = "ON_SORT_RP";
    ACTION["CTA_WHATSAPP"] = "CTA_WHATSAPP";
    ACTION["CTA_TELEGRAM"] = "CTA_TELEGRAM";
    ACTION["CTA_COPY_LINK"] = "CTA_COPY_LINK";
    ACTION["CTA_SHARE_LINK"] = "CTA_SHARE_LINK";
    ACTION["KNOW_MORE"] = "KNOW_MORE";
    ACTION["FAQ"] = "FAQ";
    ACTION["GO_TO_HOME"] = "GO_TO_HOME";
    ACTION["GO_TO_FAQ"] = "GO_TO_FAQ";
    ACTION["GO_TO_WHATSAPP"] = "GO_TO_WHATSAPP";
    ACTION["GO_TO_CALL"] = "GO_TO_CALL";
    ACTION["LOGOUT"] = "LOGOUT";
    ACTION["OPEN_MENU"] = "OPEN_MENU";
    ACTION["HANDLE_CONNECTION"] = "HANDLE_CONNECTION";
})(ACTION || (ACTION = {}));
